// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3B3w5"};